export enum LocalFilterTypes {
  ClassLocation = 'ClassLocationType',
  AcceptanceCategory = 'AcceptanceCategory',
  HMCA = 'ConsequenceAreaType'
}
